import { createContext, useContext } from 'react';

export const SpaceContext = createContext(null);

export const SpaceProvider = SpaceContext.Provider;

export const useSpaceContext = () => useContext(SpaceContext);
